import { render, staticRenderFns } from "./IBtnDestroy.vue?vue&type=template&id=52771090&"
import script from "./IBtnDestroy.vue?vue&type=script&lang=js&"
export * from "./IBtnDestroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports